import { ApplicationStore } from "src/store";

/**
 * Given a lender name (like LoanOffer.lender or LeaseOffer.lender)
 * returns a fully-qualified API URL that can be used as Img src for a logo.
 * Note, this API will 404 if the lender has no logo on file, so the Img that uses this should also have an unloader prop
 * @param state
 * @param bankName
 */
export const getBankLogoSrc = (state: ApplicationStore, bankName: string): string => {
    const kebabBank = bankName.toLowerCase().replace(/[^a-z]+/, "-");
    return `https://${state.onlineShopper.env}.api.onlineshopper.dealerinspire.com/v2/banks/${kebabBank}/logo`;
};
